import React, { Children } from 'react';
import PropTypes from 'prop-types';

import Button from './Button';

class DashedButton extends React.PureComponent {
  render() {
    return (
      <Button
        style={this.props.style}
        onClick={this.props.onClick}
        type={this.props.type}
        disabled={this.props.disabled}
        aria-label={this.props['aria-label']}
      >
        {this.props.icon}

        <span>{Children.toArray(this.props.children)}</span>
      </Button>
    );
  }
}

DashedButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit']),
  icon: PropTypes.node,
  children: PropTypes.node,
  style: PropTypes.shape({}),
  disabled: PropTypes.bool,
  'aria-label': PropTypes.string,
};

DashedButton.defaultProps = {
  onClick: () => {},
  type: 'button',
  children: null,
  style: {},
  icon: null,
  disabled: false,
  'aria-label': undefined,
};

export default DashedButton;
